import { SIZES } from "../utils/enums";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import React, { forwardRef, useCallback } from "react";

interface GenericAutocompleteProps {
  size?: (typeof SIZES)[keyof typeof SIZES];
  options: string[];
  value: string[];
  onChangeHandler: (event: React.SyntheticEvent, newValue: string[]) => void;
  freeSolo?: boolean;
  placeholder?: string;
  disableCloseOnSelect?: boolean;
  openOnFocus?: boolean;
}

const GenericAutocomplete = forwardRef<
  HTMLInputElement | null,
  GenericAutocompleteProps
>(
  (
    {
      size = SIZES.md,
      options,
      value,
      onChangeHandler,
      freeSolo = false,
      placeholder,
      disableCloseOnSelect = false,
      openOnFocus = false,
    },
    ref
  ) => {
    const renderTagChips = useCallback(
      (tagValue, getTagProps) =>
        tagValue.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={key}
              label={option}
              {...tagProps}
              sx={{
                "& .MuiChip-deleteIcon": {
                  color: "var(--color-neutral-dark)",
                },
              }}
            />
          );
        }),
      []
    );

    const renderInput = useCallback(
      (params) => (
        <TextField
          {...params}
          inputRef={ref}
          sx={{
            "& .MuiOutlinedInput-root": {
              "&.Mui-focused fieldset": {
                borderColor: "var(--color-neutral-dark)",
              },
            },
          }}
          placeholder={placeholder}
        />
      ),
      []
    );

    return (
      <Autocomplete
        disableCloseOnSelect={disableCloseOnSelect}
        openOnFocus={openOnFocus}
        multiple
        size={size}
        options={options}
        value={value}
        onChange={onChangeHandler}
        freeSolo={freeSolo}
        renderTags={renderTagChips}
        renderInput={renderInput}
      />
    );
  }
);
export default GenericAutocomplete;
